export default __webpack_public_path__ + "static/media/b_creativity_large.98780710.png";